var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuepurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2850_22469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65565 0.621094C9.92239 0.756777 9.98612 0.988568 9.97944 1.26662C9.97019 1.66236 9.98201 2.05861 9.97584 2.45487C9.96967 2.83982 9.76358 3.02638 9.43208 2.96111C9.24089 2.92359 9.0975 2.75296 9.09185 2.5078C9.08105 2.04371 9.08825 1.5791 9.08876 1.115C9.08876 0.898113 9.21776 0.753693 9.36835 0.621608H9.65565V0.621094Z",
    fill: "url(#paint0_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16395 16.6576C6.87768 15.7274 6.31902 14.9888 5.59126 14.3557C4.42048 13.337 3.73487 12.0506 3.54419 10.5067C3.19625 7.68767 4.937 5.02798 7.56381 4.09464C8.41285 3.79295 9.28966 3.71895 10.1865 3.81094C11.5495 3.95074 12.7239 4.50426 13.703 5.44376C14.6764 6.37761 15.2787 7.52115 15.4884 8.86616C15.714 10.315 15.4396 11.6636 14.6995 12.9192C14.3855 13.4516 13.9856 13.9209 13.5164 14.3248C12.7794 14.959 12.2428 15.7253 11.9468 16.6556C11.9262 16.672 11.9031 16.6808 11.8769 16.6813C11.3999 16.6849 10.9225 16.6823 10.445 16.6823C10.37 16.6823 10.2944 16.6833 10.2235 16.6551C10.113 16.5821 10.168 16.4824 10.1896 16.396C10.4358 15.4221 10.6979 14.4518 10.9523 13.4799C11.2499 12.3425 11.5459 11.2051 11.8496 10.0693C11.8728 9.98348 11.9021 9.88943 11.8214 9.82005C11.7402 9.75015 11.6646 9.81234 11.5983 9.85602C11.3809 9.99787 11.1836 9.94597 10.9913 9.80411C10.831 9.68591 10.6722 9.57335 10.4558 9.57695C10.2677 9.58003 10.1135 9.64685 9.96858 9.76094C9.65456 10.0092 9.47828 10.004 9.16836 9.75015C8.88106 9.51528 8.51205 9.50551 8.2304 9.74707C7.98884 9.9547 7.75243 10.0184 7.47078 9.82827C7.3536 9.74912 7.27599 9.80926 7.28524 9.95316C7.28987 10.0215 7.31197 10.0873 7.32893 10.1531C7.84597 12.1796 8.36351 14.2061 8.88569 16.2316C8.92012 16.3657 9.02703 16.5106 8.89186 16.652C8.71814 16.7085 8.53877 16.6803 8.36249 16.6818C7.98679 16.6854 7.61058 16.6854 7.23488 16.6823C7.20867 16.6818 7.18502 16.6736 7.16395 16.6576Z",
    fill: "url(#paint1_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9179 20.0401C11.8855 20.4656 11.5746 20.7426 11.0982 20.7478C10.9409 20.7493 10.851 20.7884 10.76 20.9313C10.1638 21.8672 8.85529 21.8466 8.27915 20.8958C8.21336 20.7868 8.14912 20.7504 8.02526 20.7483C7.53135 20.7401 7.21938 20.4677 7.18957 20.0344C7.16079 19.7898 7.18238 19.7548 7.42547 19.7538C8.84501 19.7487 10.2645 19.7482 11.6846 19.7538C11.9241 19.7548 11.9441 19.7888 11.9174 20.0396L11.9179 20.0401Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9105 16.6583C11.9218 16.6552 11.9331 16.6541 11.9444 16.6552C11.9444 16.778 11.9465 16.9003 11.9429 17.0232C11.9372 17.1979 11.9213 17.35 12.15 17.4338C12.3361 17.5016 12.3962 17.7016 12.3571 17.901C12.3191 18.0953 12.2107 18.233 11.9994 18.2628C11.9486 18.2793 11.9172 18.3276 11.8663 18.3445C11.7728 18.3728 11.6767 18.3671 11.5811 18.3671C10.2273 18.3677 8.8741 18.3677 7.52035 18.3671C7.42475 18.3671 7.32864 18.3723 7.23511 18.3445C7.1796 18.3132 7.12615 18.2777 7.06293 18.2623C6.83731 18.2078 6.70728 18.0588 6.69597 17.8424C6.68518 17.6327 6.80801 17.4225 7.01256 17.3742C7.14825 17.3423 7.16829 17.2812 7.16367 17.166C7.15698 16.9964 7.1611 16.8268 7.16007 16.6567C7.17137 16.6567 7.18217 16.6583 7.19296 16.6603C7.28804 16.7718 7.25618 16.9075 7.25515 17.0334C7.25412 17.1907 7.32042 17.2514 7.47512 17.2514C8.85971 17.2503 10.2448 17.2503 11.6294 17.2514C11.7867 17.2514 11.8473 17.1856 11.8463 17.0309C11.8458 16.905 11.8134 16.7693 11.9095 16.6583H11.9105Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06237 18.2625C7.11223 18.261 7.16362 18.2533 7.196 18.3052C7.26179 18.3782 7.25254 18.4697 7.25665 18.5581C7.26795 18.7955 7.27875 18.8058 7.52236 18.8104C7.57684 18.8114 7.63183 18.8104 7.68631 18.8104C8.9568 18.8104 10.2273 18.8104 11.4978 18.8104C11.8241 18.8104 11.8534 18.8125 11.8473 18.4959C11.8457 18.4275 11.855 18.3586 11.9059 18.3047C11.9259 18.2677 11.9603 18.261 11.9984 18.262C11.8802 18.444 11.9629 18.6444 11.95 18.8356C11.9465 18.8926 12.0215 18.8865 12.0621 18.905C12.2538 18.9918 12.3658 19.1362 12.3653 19.349C12.3648 19.5613 12.2594 19.7304 12.058 19.7843C11.8925 19.8285 11.9747 19.9637 11.9156 20.0398C11.9321 19.8666 11.8637 19.8131 11.6818 19.8141C10.2627 19.8229 8.84424 19.8219 7.42522 19.8147C7.25254 19.8136 7.1667 19.8522 7.18778 20.0346C7.17082 19.9041 7.12456 19.8198 6.97552 19.7725C6.78587 19.7129 6.69181 19.5438 6.69541 19.3403C6.69952 19.1275 6.80797 18.9672 7.00841 18.9091C7.14512 18.8695 7.18572 18.8037 7.16054 18.6814C7.13124 18.5411 7.24997 18.3653 7.06237 18.2625Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 9.3186C17.7718 9.34122 18.0458 9.28931 18.3156 9.34893C18.5397 9.39827 18.6856 9.57352 18.6784 9.77756C18.6712 9.9744 18.5237 10.1353 18.3146 10.1882C18.1588 10.2273 18.0021 10.2134 17.8463 10.2098C17.4583 10.2011 17.0682 10.2463 16.6822 10.1831C16.4762 10.1491 16.3251 9.97132 16.3204 9.77448C16.3158 9.57404 16.453 9.40135 16.6643 9.3515C16.9408 9.28674 17.2219 9.34225 17.5005 9.3186H17.4999Z",
    fill: "url(#paint2_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.55175 9.3233C1.79022 9.3233 2.02921 9.31456 2.26717 9.32586C2.519 9.3382 2.69478 9.48879 2.73178 9.70927C2.76519 9.90766 2.67833 10.0526 2.50616 10.1451C2.40902 10.1975 2.29852 10.2104 2.18956 10.2109C1.76709 10.2129 1.34463 10.2171 0.922672 10.2099C0.520762 10.2032 0.29411 9.91074 0.430307 9.58952C0.518192 9.3824 0.700645 9.33255 0.898003 9.32432C1.1154 9.31559 1.33383 9.32227 1.55175 9.32227V9.3233Z",
    fill: "url(#paint3_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40705 3.16108C3.49957 3.15389 3.61263 3.23612 3.70977 3.3312C4.03202 3.64625 4.35118 3.96439 4.66469 4.28818C4.78907 4.41718 4.89032 4.5616 4.82093 4.76409C4.71866 5.06167 4.38305 5.1881 4.1528 4.97738C3.76065 4.61865 3.39112 4.2337 3.02159 3.8508C2.90287 3.72797 2.89413 3.56351 2.97431 3.41086C3.0514 3.26336 3.17475 3.17188 3.40757 3.1616L3.40705 3.16108Z",
    fill: "url(#paint4_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1327 3.58963C16.1281 3.71709 16.0767 3.82553 15.9862 3.91599C15.6485 4.25417 15.314 4.59543 14.9712 4.92847C14.7707 5.12326 14.5297 5.12583 14.3518 4.95417C14.1735 4.78148 14.1576 4.55791 14.3436 4.35233C14.6911 3.9679 15.0539 3.59631 15.446 3.25659C15.5771 3.14301 15.7328 3.13067 15.8865 3.21085C16.0361 3.28897 16.1173 3.41848 16.1327 3.58963Z",
    fill: "url(#paint5_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84737 14.8879C4.83041 15.0174 4.7749 15.1248 4.68548 15.2142C4.35295 15.5478 4.02299 15.8834 3.68635 16.2123C3.48129 16.4127 3.25309 16.4205 3.06653 16.2478C2.8887 16.0828 2.86557 15.8459 3.04905 15.6434C3.397 15.2594 3.75985 14.8889 4.15148 14.5486C4.28922 14.4289 4.44803 14.4227 4.60838 14.508C4.76103 14.5892 4.82167 14.729 4.84737 14.8879Z",
    fill: "url(#paint6_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14 15.9375C16.1225 16.0948 16.0547 16.2269 15.9036 16.3112C15.7489 16.3975 15.5895 16.396 15.4641 16.2819C15.0607 15.9144 14.6701 15.5325 14.3098 15.1229C14.1628 14.9564 14.2034 14.7231 14.3627 14.5699C14.5123 14.4265 14.7374 14.4018 14.9034 14.5437C15.3084 14.8891 15.6764 15.2735 16.0351 15.6661C16.1019 15.7391 16.1276 15.8311 16.14 15.937V15.9375Z",
    fill: "url(#paint7_linear_2850_22469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92077 16.6212C8.58516 15.3065 8.24955 13.9913 7.91394 12.6767C7.68781 11.7911 7.46115 10.9061 7.23501 10.0206C7.20983 9.92291 7.16101 9.82115 7.27767 9.74509C7.38817 9.67262 7.46475 9.73532 7.55007 9.80316C7.71916 9.93833 7.953 9.91829 8.12878 9.76359C8.52041 9.41924 8.8627 9.41616 9.25484 9.7528C9.46762 9.93525 9.65984 9.93885 9.88289 9.76462C10.3275 9.41719 10.5536 9.41616 11.0146 9.75691C11.2377 9.92189 11.3805 9.93062 11.5928 9.79391C11.6725 9.74252 11.7547 9.66902 11.8534 9.73635C11.9618 9.81036 11.9449 9.91932 11.9156 10.0314C11.5106 11.5681 11.1076 13.1048 10.7047 14.642C10.5315 15.3014 10.3604 15.9618 10.1877 16.6212C10.0653 16.7076 9.93531 16.6855 9.80426 16.6485C9.71175 16.5637 9.77291 16.4691 9.79552 16.3833C10.3028 14.4477 10.8075 12.5117 11.3137 10.5761C11.3775 10.333 11.3744 10.332 11.1246 10.2709C10.9694 10.2328 10.8342 10.1562 10.7078 10.0591C10.4714 9.87717 10.3562 9.87717 10.1224 10.0504C9.66652 10.3875 9.39772 10.3865 8.93825 10.0463C8.71262 9.87923 8.61035 9.87409 8.38627 10.035C8.2182 10.1557 8.04757 10.2662 7.83634 10.2924C7.67393 10.3125 7.71145 10.4199 7.73869 10.5217C7.95866 11.3322 8.17349 12.1442 8.39243 12.9552C8.70337 14.109 9.00969 15.2644 9.32166 16.4177C9.3417 16.4917 9.38539 16.575 9.30624 16.6459C9.17467 16.687 9.04464 16.7081 8.92129 16.6212H8.92077Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92117 16.6216C9.0548 16.6391 9.18843 16.6401 9.32154 16.6216C9.47675 16.5265 9.63145 16.5265 9.78667 16.6216C9.92029 16.6406 10.0544 16.6396 10.1881 16.6226C10.6907 16.6257 11.1934 16.6278 11.696 16.6334C11.7679 16.6345 11.8456 16.6082 11.9124 16.6596C11.9119 16.8231 11.9057 16.987 11.9124 17.1505C11.917 17.2692 11.8841 17.3206 11.753 17.3206C10.2878 17.317 8.82249 17.317 7.35722 17.3206C7.22924 17.3206 7.19018 17.2743 7.19584 17.153C7.20303 16.9896 7.19687 16.8262 7.19584 16.6622C7.31096 16.6 7.43483 16.636 7.55406 16.6339C8.00994 16.6262 8.46581 16.6257 8.92117 16.6226V16.6216Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9091 18.304C11.9091 18.4268 11.8998 18.5507 11.9132 18.6725C11.9312 18.839 11.8633 18.8786 11.705 18.8775C10.5923 18.8714 9.47912 18.8744 8.36641 18.8744C8.03183 18.8744 7.69725 18.8703 7.36267 18.8765C7.24035 18.8786 7.18792 18.8415 7.19615 18.7136C7.20488 18.5774 7.19872 18.4407 7.19923 18.304C8.76935 18.304 10.3395 18.304 11.9096 18.304H11.9091Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78423 16.6206C9.62902 16.6371 9.47432 16.6371 9.3191 16.6206C8.76249 14.553 8.2064 12.4854 7.64773 10.4183C7.61587 10.3011 7.62615 10.2497 7.76748 10.2451C7.98643 10.2384 8.16991 10.1356 8.339 9.99736C8.57953 9.80052 8.73834 9.8072 8.97578 10.004C9.37461 10.3345 9.68761 10.333 10.0926 9.99736C10.3151 9.81285 10.4935 9.80309 10.7145 9.99325C10.882 10.1377 11.0655 10.2379 11.2834 10.243C11.4607 10.2471 11.4366 10.3304 11.4057 10.4471C11.1472 11.4297 10.8918 12.4129 10.6338 13.3956C10.3516 14.4708 10.0674 15.5455 9.78423 16.6201V16.6206Z",
    fill: "#FED05C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_22469",
    x1: 9.85168,
    y1: 0.958544,
    x2: 8.74692,
    y2: 1.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2850_22469",
    x1: 13.8347,
    y1: 5.62604,
    x2: 4.72447,
    y2: 14.1377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2850_22469",
    x1: 18.3404,
    y1: 9.44751,
    x2: 17.9175,
    y2: 10.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2850_22469",
    x1: 2.40204,
    y1: 9.44806,
    x2: 1.98155,
    y2: 10.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2850_22469",
    x1: 4.56792,
    y1: 3.4362,
    x2: 3.20937,
    y2: 4.79502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2850_22469",
    x1: 15.8571,
    y1: 3.43473,
    x2: 14.4998,
    y2: 4.79361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2850_22469",
    x1: 4.57121,
    y1: 14.7258,
    x2: 3.21358,
    y2: 16.0873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2850_22469",
    x1: 15.8644,
    y1: 14.7248,
    x2: 14.5046,
    y2: 16.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2850_22469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2833,
    height: 21,
    fill: "white",
    transform: "translate(0.390625 0.621094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuepurpose);
export default __webpack_public_path__ + "static/media/valuepurpose.685eb716a3edb149ac7af59cc1a405f8.svg";
export { ForwardRef as ReactComponent };